import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a906094"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IciButton',
  props: {
  selected: { type: Boolean },
  btnStyle: { type:String },
  content: { type:String },
  id: { type: String, required: true },
  dark: { type: Boolean, default: false },
  hover: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }

},
  emits: ['buttonClick', 'submit'],
  setup(__props, { emit: __emit }) {

const emit = __emit

function buttonClick() {
  emit('buttonClick')
}


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (__props.hover=true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (__props.hover=false)),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (buttonClick())),
    disabled: __props.disabled,
    class: _normalizeClass(["button-default header-button ici_button", [!__props.hover ? (__props.dark ? 'button-normal-dark' : 'button-normal') : 'button-over']]),
    style: _normalizeStyle(__props.btnStyle)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: __props.content,
        style: {"text-align":"center","width":"100%","display":"flex","align-items":"center","gap":"8px","justify-content":"center","text-wrap":"nowrap"}
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["disabled", "class", "style"]))
}
}

})